import React, { useState } from "react";
import InputField from "@/app/components/input";
import CalendarInput from "../../calendar-input";
import CalendarIcon from "../../svg/calendar";
import Button from "../../button";
import ArrowRight from "../../svg/arrow-right";
import Pin from "../../svg/pin";
import Square from "../../svg/square";

interface Step1Props {
    onNext: (data: any) => void;
    initialData: any;
    lang?: string;
    id?: string;
}

const Step1: React.FC<Step1Props> = ({ onNext, initialData, lang, id }) => {
    const [data, setData] = useState({
        date: initialData.date || null,
        squareMetersFrom: initialData.squareMetersFrom || "",
        address: initialData.address || "",
    });

    const [errors, setErrors] = useState({
        date: false,
        squareMetersFrom: false,
        address: false,
    });

    const handleNext = () => {
        const newErrors = {
            date: !data.date,
            squareMetersFrom: !data.squareMetersFrom.trim(),
            address: !data.address.trim(),
        };

        setErrors(newErrors);

        if (!Object.values(newErrors).some((error) => error)) {
            onNext(data);
        }
    };

    const requredText = lang === 'en' ? 'This field is required' : 'Detta fält är obligatoriskt';

    return (
        <div id={id} className="rounded-[40px] p-[48px] shadow-[0_10px_24px_0_#00000026] max-[576px]:p-[20px] max-[576px]:rounded-[20px]">
            <h2 className="text-[32px] font-bold text-violet-500 mb-[40px] max-[576px]:text-[20px] max-[576px]:leading-[24px] max-[576px]:mb-[24px]">
                {lang === 'en' ? 'Please fill in the required information' : 'Vänligen fyll i nödvändig information'}
            </h2>
            <div className="space-y-[32px]">
                <div className="grid grid-cols-2 gap-6 max-[576px]:grid-cols-1">
                    <div className="space-y-6">
                        <h3 className="font-medium text-sm text-violet-500 leading-[143%] uppercase mb-[8px] max-[576px]:text-[12px] max-[576px]:leading-[12px]">
                            {lang === 'en' ? 'please write the square meters of the space ' : 'skriv utrymmets kvadratmeter'}
                        </h3>
                        <InputField
                            label= {lang === 'en' ? 'square meters ' : 'kvadratmeter'}
                            type="number"
                            placeholder={lang === 'en' ? 'Please write square meters ' : 'Skriv gärna kvadratmeter'}
                            value={data.squareMetersFrom}
                            iconLeft={<Square />}
                            onChange={(e) =>
                                setData({ ...data, squareMetersFrom: e.target.value })
                            }
                            errorMessage={errors.squareMetersFrom ? requredText : ""}
                        />
                    </div>
                    <div className="space-y-6">
                        <h3 className="font-medium text-sm text-violet-500 leading-[143%] uppercase mb-[8px] max-[576px]:text-[12px] max-[576px]:leading-[12px]">
                            {lang === 'en' ? 'please select required cleaning date ' : 'vänligen välj önskat städdatum'}
                        </h3>
                        <CalendarInput
                            label={lang === 'en' ? 'date ' : 'datum'}
                            value={data.date}
                            onChange={(date) => setData({ ...data, date })}
                            icon={<CalendarIcon />}
                            placeholder="YYYY/MM/DD"
                            errorMessage={errors.date ? requredText : ""}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-6 max-[576px]:grid-cols-1">
                    <div className="mt-[28px] max-[576px]:mt-[0]">
                        <InputField
                            label={lang === 'en' ? 'Address ' : 'adress'}
                            placeholder={lang === 'en' ? 'Address ' : 'adress'}
                            iconLeft={<Pin />}
                            value={data.address}
                            onChange={(e) => setData({ ...data, address: e.target.value })}
                            errorMessage={errors.address ? requredText : ""}
                        />
                    </div>
                </div>
            </div>
            <div className="flex justify-end mt-[40px] max-[576px]:mt-[24px]">
                <Button
                    onClick={handleNext}
                    mobileFull="yes"
                    text={lang === 'en' ? 'continue' : 'fortsätta' }
                    icon={<ArrowRight />}
                    type="primary"
                    iconPostiton="right"
                    size="big"
                />
            </div>
        </div>
    );
};

export default Step1;